export class ResearcherName {
    firstName: string;
    lastName: string;
    middleName: string;
    nameSuffix: string;
    namePrefix?: string;
    isDefaultName?: boolean;
    isAdditionalName?: boolean;

    constructor(first, middle, last, suffix, prefix = "", isDefaultName = false, isAdditionalName = false){
        this.firstName = first;
        this.middleName = middle;
        this.lastName = last;
        this.nameSuffix = suffix;
        this.namePrefix = prefix;
        this.isDefaultName = isDefaultName;
        this.isAdditionalName = isAdditionalName;
    }
}
